module.exports = __webpack_public_path__ + "static/media/east tower final shot 01.b0eaa055.webp";